<template>
    <ai-grid-virtual-wrapper
        ref="gridVirtualRef"
        :custom-context-menu="customContextMenu"
        :meta="meta"
        @gridVirtualWrapperMounted="onGridVirtualWrapperMounted"
        @focusedRowChanging="handleFocusedRowChanged"
        @selection-changed="onSelectionChanged"
        @toolbar-button-click="toolbarButtonClick"
    />
</template>
<script>
export default { name: 'view-hv-eosrc-new' };
</script>
<script setup>
import { useRouter } from 'vue-router';
import { setTabTitle } from '@/layouts/main-layout/components/navigation-bars-data';
import { ref, nextTick } from 'vue';
import AiCustomConfirmDialog from '@/utils/ai-custom-confirm-dialog';
import { commitDataChanges } from '@/service/meta-service';
import { dxUiNotify } from '@/utils/dx-helper';
import AiGridVirtualWrapper from '@/components/wrappers/ai-grid-virtual-wrapper.vue';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import { getUserDataChanges, saveUserDataChanges } from '@/service/userdata-service';

const gridVirtualRef = ref();
const router = useRouter();
const columns = [
    { field: 'eobj_id', text: 'ID', visible: false },
    { field: 'kod_srckind', text: 'kod_srckind', visible: false },
    { field: 'kindname', text: 'Вид энергообъекта', width: 70 },
    { field: 'dnum', text: 'Диспетчерский №' },
    { field: 'sname', text: 'Оперативное наименование' },
    { field: 'fname', text: 'Полное наименование' },
    { field: 'kodp_seti', text: 'kodp_seti', visible: false, data_type: 'ARRAY' },
    { field: 'setiname', text: 'Зона филиала', visible: false },
    { field: 'setiname_str', text: 'Зона филиала', width: 200 },
    { field: 'bal_id', text: 'bal_id', visible: false },
    { field: 'bkod_separator', text: 'bkod_separator', visible: false },
    { field: 'bkod_ecls', text: 'bkod_ecls', visible: false },
    { field: 'bname', text: 'Балансовая принадлежность', width: 200 },
    { field: 'expl_id', text: 'expl_id', visible: false },
    { field: 'ekod_parent', text: 'ekod_parent', visible: false },
    { field: 'ekod_separator', text: 'ekod_separator', visible: false },
    { field: 'ename', text: 'Эксплуатационная ответственность', width: 200 },
    { field: 'schema_invalid', text: 'В схеме энергообъекта есть ошибки', width: 100, alignment: 'center' },
    { field: 'is_uc', text: 'Строящийся', alignment: 'center' },
    { field: 'vltgs', text: 'ВН(/СН/)НН, кВ' },
    { field: 'addr_id', text: 'addr_id', visible: false },
    { field: 'addrkind', text: 'addrkind', visible: false },
    { field: 'adr', text: 'Адрес', width: 200 },
    { field: 'latitude', text: 'Коорд: широта (градусы)' },
    { field: 'longitude', text: 'Коорд: долгота (градусы)' },
    { field: 'yearofplugin', text: 'Год ввода в эксплуатацию' },
    { field: 'yearofpluginafterreconstr', text: 'Год ввода в эксплуатацию после реконструкции' },
    { field: 'coment', text: 'Комментарий', width: 200 },
    { field: 'tech_location_code', text: 'Код технического места оборудования в SAP (или ее аналога)', visible: false },
    { field: 'imported', text: 'Импортирован', width: 100, alignment: 'center' },
    { field: 'deleted', text: 'deleted', visible: false, width: 100, alignment: 'center' },
    { field: 'kod_v', text: 'kod_v', visible: false },
    { field: 'kod_v_low', text: 'kod_v_low', visible: false },
    { field: 'kod_v_mdl', text: 'kod_v_mdl', visible: false },
];
const meta = {
    columns: columns,
    loadUrl: 'e-grid./eosrc/data/get',
    keyExpr: 'eobj_id',
    createViewRoutName: 'EosrcCardNew',
    toRemoveToolbarItemsNames: ['choice', 'copy', 'save'],
    viewId: 'hv-eosrc-view',
};

const customContextMenu = [
    {
        text: 'Открыть карточку ЭО',
        onItemClick: e => {
            router.push({ name: 'EosrcCard', params: { id: e.itemData.rowData.key } });
        },
    },
    {
        text: 'Распределительная сеть',
        onItemClick: e => {
            setTabTitle(`Распред. сеть ${e.itemData.rowData.data['kindname']} ${e.itemData.rowData.data['dnum']}`);
            router.push({ name: 'EoschemaFull', params: { id: e.itemData.rowData.key } });
        },
    },
];

const hvEosrcNewInstance = ref();

const onSelectionChanged = async e => {
    const gridInstance = gridVirtualRef.value.gridInstance.gridInstance.gridInstance;

    const scrollTop = gridInstance.getScrollable().scrollTop(); // Save position
    const scrollLeft = gridInstance.getScrollable().scrollLeft();

    if (e.currentSelectedRowKeys.length > 0) {
        await gridInstance.getScrollable().scrollTo(e.currentSelectedRowKeys[0]);
    } else if (e.currentDeselectedRowKeys.length > 0) {
        await gridInstance.getScrollable().scrollTo(e.currentDeselectedRowKeys[0]);
    }

    await nextTick();
    await gridInstance.getScrollable().scrollTo({ top: scrollTop, left: scrollLeft });
};

const handleFocusedRowChanged = async e => {
    const { changes } = await getUserDataChanges({ viewId: 'view-hv-eosrc-new' });
    const focusRowKey = e?.rows.find(item => item.dataIndex === e.newRowIndex);
    let args = {};
    if (changes) {
        args = { ...changes, rowKey: focusRowKey.key };
    } else {
        args.rowKey = focusRowKey.key;
    }
    await saveUserDataChanges({ changes: args, viewId: 'view-hv-eosrc-new' });
};

const onGridVirtualWrapperMounted = async () => {
    hvEosrcNewInstance.value = {
        refresh: () => {},
        userData: () => {},
        userSettings: gridVirtualRef.value.fetchAndSetUserSettings,
    };
    setActiveViewInfo(hvEosrcNewInstance.value);

    const gridInstance = gridVirtualRef.value.gridInstance.gridInstance.gridInstance;
    const { changes } = await getUserDataChanges({ viewId: 'view-hv-eosrc-new' });
    if (changes?.rowKey) {
        gridInstance.option('focusedRowKey', changes.rowKey);
    } else {
        gridInstance.option('focusedRowKey', -1);
    }

    await setViewData();
};

const toolbarButtonClick = async e => {
    if (e.item.component.name === 'edit') {
        const key = gridVirtualRef.value.gridInstance.gridInstance.gridInstance.option('focusedRowKey');
        const rowData = gridVirtualRef.value.gridInstance.gridInstance.gridInstance
            .option('dataSource')
            .items()
            .find(row => row[meta.keyExpr] === key);
        await router.push({ name: 'EosrcCard', params: { id: key } });
    } else if (e.item.component.name === 'add') {
        setTabTitle('Энергообъект');
        await router.push({ name: 'EosrcCardNew' });
    } else if (e.item.component.name === 'delete') {
        const result = await AiCustomConfirmDialog('ЭО будет удален в корзину. Продолжить?', 'Запрос на удаление');
        if (result === -1 || result === 0) {
            gridVirtualRef.value.gridInstance.gridInstance.gridInstance.clearSelection();
            return;
        }
        const processedData = {
            insertDataArgs: [],
            updateDataArgs: [],
            deleteDataArgs: gridVirtualRef.value.gridInstance.gridInstance.gridInstance.getSelectedRowsData(),
        };
        if (processedData.deleteDataArgs.length > 0) {
            const { errors } = await commitDataChanges('e-grid./eosrc/set', processedData, {});
            //Про валидацию пока забыли
            if (errors?.length > 0) {
                dxUiNotify(`Ошибка базы данных: ${errors.map(error => error.message).join('\n')}`, 'error');
            } else {
                dxUiNotify('Изменения данных прошли успешно', 'success');
                gridVirtualRef.value.gridInstance.gridInstance.gridInstance.refresh();
            }
        }
    }
};
</script>
